import { LoadType } from '@tencent/ark-extensions';

/**
 * group-creator用于向qq群push消息
 */
export default {
    name: 'docs-component-group-creator',
    loadType: LoadType.ON_DEMAND,
};
